import { Theme, css } from '@emotion/react';

export const container = (theme: Theme, gutterBottom: boolean) => css`
  ${gutterBottom ? `margin-bottom: ${theme.spacing(2)}px;` : ''}
`;

export const titleContainer = (theme: Theme, subtitle: boolean) => css`
  ${subtitle ? `margin-bottom: ${theme.spacing(0.5)}px;` : ''}
`;

export const title = (lineClamp: number) => css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: ${lineClamp};
`;
